import React from 'react';
import { Button } from 'primereact/button';
import { useFileManagerContext } from 'modules/file_manager/context/FileManagerContext';
import { handleRedirection } from 'utils/utils';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { generateFullName } from 'utils/generateFullNameUtils';

function CreateTimeline() {
  const { caseDetails, isCaseFileManager, files } = useFileManagerContext();
  const history = useHistory();

  return (
    <Button
      label="Create Timeline"
      className="p-button-primary outline"
      onClick={() => {
        const caseDataToPass = {};
        if (caseDetails?.is_lead) {
          caseDataToPass['main_client_name'] = generateFullName(caseDetails?.main_client[0]);
        } else {
          caseDataToPass['case_name'] = caseDetails?.case_description?.case_name;
        }

        const timelineFolder = files?.find((file) => file.display_name === 'Timeline');
        if (timelineFolder) {
          caseDataToPass['timelineFolder'] = {
            folderName: timelineFolder.display_name,
            object_id: timelineFolder.object_id,
          };
        }
        if (caseDataToPass) {
          localStorage.setItem('caseData', JSON.stringify(caseDataToPass));
        }
        const url = `/timeline/${isCaseFileManager ? 'cases' : 'leads'}/${caseDetails?.case_id}`;
        handleRedirection(history, url, caseDataToPass);
      }}
    />
  );
}

export default CreateTimeline;
